import { DateTimeHelper } from "src/app/core/helper/datetime.helper";
import { Prize } from "./prize";

export class Raffle {
    name: string;
    description: string;
    saleStart: string;
    saleEnd: string;
    prizes: Prize[] = [];
    ticketsSold: number;
    currency: string;
    
    public constructor(init?: Partial<Raffle>) {
        Object.assign(this, init);
        if (this.prizes != null ) this.prizes = this.prizes.map(m => new Prize(m));
        this.refreshDisplayDates();
    }

    private refreshDisplayDates() {
        if (this.saleStart != null) {
            this.saleStart  = DateTimeHelper.formatDateShort(`${this.saleStart}Z`);
        }
        if (this.saleEnd != null) {
            this.saleEnd  = DateTimeHelper.formatDateShort(`${this.saleEnd}Z`);
        }
    }
}


